<div class="media-outer">
    <video ref:video muted={{$isMobile.any}} playsinline bind:currentTime="t" bind:duration="d" bind:paused on:ended="advance()" on:loadstart="set({ loading: true })" on:canplay="set({ loading: false })" loop="{{ slide.loop }}" poster="{{ poster(slide.poster) }}">
        {{#if slide.webm }}<source src="{{ video(slide.webm) }}" type="video/webm">{{/if}}
        {{#if slide.mp4 }}<source src="{{ video(slide.mp4) }}" type="video/mp4">{{/if}}
        {{#if slide.vtt }}
        <track ref:track src="{{ slide.vtt }}" label="English captions" kind="metadata" srclang="en" default>
        {{/if}}
    </video>
</div>

<Captions ref:display :cues />

{{#if truthy(slide.controls) }}
<Progress ref:progress :t :d :paused on:toggle="toggle()" />
{{/if}}

{{#if loading}}
<span class="loading" transition:fade>Loading...</span>
{{/if}}

<script>
import Slide from './Slide.html'
import Captions from './video/Captions.html'
import Progress from './video/Progress.html'
import Modal from './Modal.html'

import { truthy, noop, video, poster, syncCues } from './helpers'

import { fade } from 'svelte-transitions'

export default {

    components: {
        Captions,
        Progress,
    },

    transitions: { fade },

    data() {
        return {
            cues: [],
            i: 0,
            t: 0,
            d: 0,
            slide: {},
            paused: true,
            loading: false,
        }
    },

    oncreate () {

        //const {video, track, display} = this.refs;

        //console.log( `render ${store.get('current_chapter')} /video ${this.get('i')}`);

        this.observers = [];

        this.observers.push(this.store.observe('muted', muted => {
            this.refs.video.muted = muted;
        }, { defer: true }));

        this.observers.push(this.store.observe('current_slide', (current, prev) => {
            if (current === this.get('i')) {
                this.play();
            } else {
                this.pause();
            }
        }));

        this.observers.push(this.store.observe('modal_active', current => {
            if (current) {
                this.pause();
            } else if ( this.store.get('current_slide') == this.get('i') ) {
                this.play();
            }
        }));

        this.observers.push(this.store.observe('index_active', current => {
            if (current) {
                this.pause();
            } else if ( ( this.store.get('current_slide') == this.get('i') ) && ( this.store.get('current_chapter') == this.get('chapter') ) ) {
                //console.log( `play ${this.get('chapter')} /video ${this.get('i')}` );
                this.play();
            }
        }));

        syncCues(this.refs.track, this.refs.display);

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    methods: {
        toggle() {
            const {video} = this.refs;
            if (video && video.paused) {
                this.play();
            } else {
                this.pause();
            }
        },

        play() {
            const { video } = this.refs;
            video && video.play().catch(noop);
        },

        pause() {
            const { video } = this.refs;
            video && video.pause();
        },

        advance() {
            const { auto_advance } = this.get('slide');
            if (truthy(auto_advance)) {
                this.store.deck.next();
            }
        }
    },

    helpers: {
        truthy,
        video,
        poster,
    }
}
</script>